import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { TypeResponsabilite } from '../../../perimetres/entities/type-responsabilite.entity';

import { AgenceForPerimetreCAC } from '../entities/agence-for-perimetre-cac.entity';

@Injectable({ providedIn: 'root' })
export class PerimetreResponsabiliteService {
	private path: string;

	constructor( //
		@Inject(HttpClient) public httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: PerimetreResponsabiliteService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}
	
	public listPerimetres(responsabilite: TypeResponsabilite): Observable<AgenceForPerimetreCAC[]> {
		let url = this.path + 'agences?format=perimetre' + responsabilite;
		return this.httpClient //
			.get<AgenceForPerimetreCAC[]>(url) //
		;
	}
	
	public listPerimetresByAntenne(responsabilite: TypeResponsabilite, idAntenne: number): Observable<AgenceForPerimetreCAC[]> {
		let url = this.path + 'antennes/' + idAntenne + "?format=perimetre" + responsabilite;
		return this.httpClient //
			.get<AgenceForPerimetreCAC[]>(url) //
		;
	}
}